import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import Api from "../../../../constants/Api";
import MenuConfig from "../../../../constants/MenuConfig";
import axiosInstance from "../../../../services/AxiosInstance";
import "./EmployeeWithoutBranchNotice.css";

/**
 * Aviso de colaboradores ativos sem nenhuma filial ativa.
 *
 * Esse cadastro fica fora da agenda e dos selects, e na grade só aparece com "Todas as
 * filiais" no cabeçalho, que não é a seleção padrão. Sem o aviso o gestor não sabe que ele
 * existe. O servidor só devolve a lista para quem enxerga todas as filiais; para os demais
 * ela vem vazia e o aviso não aparece.
 */
const EmployeeWithoutBranchNotice = () => {
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        let requestIsCurrent = true;

        axiosInstance.get(`${Api.main.employee}/without-active-branch`)
            .then((response) => {
                if (requestIsCurrent) {
                    setEmployees(Array.isArray(response.data) ? response.data : []);
                }
            })
            // O aviso é complementar à listagem: uma falha aqui não deve atrapalhar a tela.
            .catch(() => {});

        return () => {
            requestIsCurrent = false;
        };
    }, []);

    if (employees.length === 0) {
        return null;
    }

    const single = employees.length === 1;

    // O ícone precisa ser o primeiro filho do alert: é por ele que o tema aplica a cor de aviso.
    return (
        <Alert variant="warning" className="employee-branch-notice">
            <i className="fas fa-triangle-exclamation employee-branch-notice__icon" aria-hidden="true" />
            <div className="employee-branch-notice__body">
                <strong className="employee-branch-notice__title">
                    {single
                        ? 'Colaborador ativo sem filial ativa'
                        : `${employees.length} colaboradores ativos sem filial ativa`}
                </strong>
                <p className="employee-branch-notice__text">
                    {single ? 'Ele não aparece' : 'Eles não aparecem'} na agenda nem na grade com uma filial
                    selecionada. Abra o cadastro para vincular a uma filial ativa ou mude a situação para Inativo.
                </p>
                <div className="employee-branch-notice__list">
                    {employees.map((employee) => (
                        <Link
                            key={employee.id}
                            to={`${MenuConfig.main.employee.route}/new/${employee.id}`}
                            className="employee-branch-notice__link"
                            title="Abrir cadastro"
                        >
                            {/* O ícone marca o nome como pendente; o que fazer já está no texto acima. */}
                            <i className="fas fa-triangle-exclamation" aria-hidden="true" />
                            <span>{employee.fullName || [employee.firstName, employee.lastName].filter(Boolean).join(' ')}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </Alert>
    );
};

export default EmployeeWithoutBranchNotice;
